import React from 'react'

class Button extends React.Component{
    onClick(event) {
        if (this.props.type === 'submit') {
            event.preventDefault();
        }
        if (this.props.params) {
            this.props.onClick({name: this.props.name, params: this.props.params});
        } else {
            this.props.onClick({name: this.props.name});
        }
    }
    render () {
        let button_className = "button " + this.props.name;
        let type = this.props.type || 'button';
        switch(this.props.status) {
            case 'disabled':
                return (
                    <button id={this.props.name} className={button_className} name={this.props.name} disabled
                            type={type} onClick={this.onClick.bind(this)}>{this.props.children}{this.props.label}
                    </button>
                );
            case 'hidden':
                return null;
            case 'active':
                button_className = button_className + ' active';
                break;
            default:
                return (
                    <button id={this.props.name} className={button_className} name={this.props.name}
                            type={type} onClick={this.onClick.bind(this)}>{this.props.children}{this.props.label}
                    </button>
                );
        }
        
    }
}

export default Button;